/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetCardProductListResponseItemCardImageDetailsOneOfCardOrientation = typeof GetCardProductListResponseItemCardImageDetailsOneOfCardOrientation[keyof typeof GetCardProductListResponseItemCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardProductListResponseItemCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
